import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './pages/routes/routes';

function App() {
	return (
		<Router>
			<Routes />
		</Router>
	);
}

export default App;
